module.exports = __webpack_public_path__ + "m.no2.6add4567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/m.no2.jpg
// module id = 9Wvj
// module chunks = 0